import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { injectIntl } from 'react-intl';

import ResendButton from './ResendButton/ResendButton';
import Popup from '../common/Popup';
import ErrorBlock from '../common/ErrorBlock';
import Button from '../Button';
import TextInput from '../TextInput';
import styles from './index.styl';

const CODE_MAX_LENGTH = 6;

const MfaDialog = ({
  counterValue,
  error,
  errorText,
  intl,
  loading,
  mfaData,
  onClose,
  onResend,
  onSubmit,
  open,
  title,
  withContentText,
}) => {
  const [code, setCode] = useState('');
  const [prevSubmittedCode, setPrevSubmittedCode] = useState('');
  const { formatMessage } = intl;

  const contentText = useMemo(() => {
    if (!mfaData) return '';

    const { email, phoneNumber } = mfaData;
    if (email && phoneNumber) {
      return formatMessage(
        { id: 'mfa.dialog.phoneAndEmailConfirmation' },
        { phone: phoneNumber, email },
      );
    } else if (email) {
      return formatMessage({ id: 'mfa.dialog.emailConfirmation' }, { email });
    } else if (phoneNumber) {
      return formatMessage(
        { id: 'mfa.dialog.phoneConfirmation' },
        { phone: phoneNumber },
      );
    }
  }, [mfaData]);

  const handleSubmit = () => {
    setPrevSubmittedCode(code);
    onSubmit(code);
  };

  const handleResend = () => {
    if (onResend) {
      onResend();
    }
  };

  const disableVerifyButton = prevSubmittedCode && prevSubmittedCode === code;

  return (
    <Popup opened={open} withHeading={false} mobileFullScreen={false}>
      <div className={styles.modalWrapper}>
        <h1 className={styles.title}>{title}</h1>

        <div className={styles.contentText}>
          {withContentText || contentText}
        </div>

        <div className={cn({ [styles.marginZero]: error })}>
          <div className={styles.label}>
            {formatMessage({ id: 'mfa.dialog.input.label' })}
          </div>
          <TextInput
            type="number"
            placeholder={formatMessage({ id: 'mfa.dialog.input.label' })}
            value={code}
            onChange={setCode}
            limit={CODE_MAX_LENGTH}
            disabled={loading}
          />
        </div>
        <If condition={error}>
          <ErrorBlock
            className={styles.errorBlock}
            errors={formatMessage({
              id: errorText || 'mfa.dialog.error.message',
            })}
          />
        </If>
        <ResendButton onResend={handleResend} counterValue={counterValue} />
        <div className={styles.actions}>
          <Button
            onClick={handleSubmit}
            disabled={
              code.length !== CODE_MAX_LENGTH || loading || disableVerifyButton
            }
            className={styles.submitButton}
            color="primary"
            raised
          >
            {formatMessage({ id: 'mfa.dialog.button.verify' })}
          </Button>
          <Button color="accent" raised onClick={onClose} disabled={loading}>
            {formatMessage({ id: 'common.cancel' })}
          </Button>
        </div>
      </div>
    </Popup>
  );
};

MfaDialog.propTypes = {
  counterValue: PropTypes.number,
  error: PropTypes.bool,
  errorText: PropTypes.string,
  intl: PropTypes.object,
  loading: PropTypes.bool,
  mfaData: PropTypes.object,
  onClose: PropTypes.func,
  onResend: PropTypes.func,
  onSubmit: PropTypes.func,
  open: PropTypes.bool,
  title: PropTypes.string,
  withContentText: PropTypes.string,
};

export default injectIntl(MfaDialog);



// WEBPACK FOOTER //
// ./src/components/MfaDialog/index.jsx